var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.endpoint)?_c('abm',{attrs:{"endpoint":'/api/' + _vm.endpoint + '/',"params":_vm.params,"tablename":_vm.endpoint}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }